import React from "react";
import { Plus, X } from "lucide-react";

export default function PostItBoard({ postIts, addPostIt, updatePostIt, persistPostIt, deletePostIt }) {
  return (
    <div className="flex-1 bg-slate-100 p-8 overflow-y-auto custom-scrollbar" data-testid="postits-view">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-outfit font-bold text-slate-900 tracking-tight">Bacheca Note</h1>
          <p className="text-slate-500 text-sm mt-1">Idee, promemoria e appunti veloci.</p>
        </div>
        <button
          onClick={addPostIt}
          className="bg-amber-400 hover:bg-amber-500 text-amber-900 px-5 py-2 rounded-full font-bold shadow-lg flex items-center gap-2 transition"
          data-testid="add-postit-btn"
        >
          <Plus size={19} strokeWidth={2.3} /> Aggiungi Nota
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 py-4">
        {postIts.length === 0 && (
          <div className="col-span-full text-center py-16 text-slate-400">
            Nessuna nota. Clicca &ldquo;Aggiungi Nota&rdquo; per iniziare.
          </div>
        )}
        {postIts.map((note) => (
          <div key={note.id} className="post-it aspect-square p-4 relative flex flex-col rounded-md" data-testid={`postit-${note.id}`}>
            <textarea
              className="w-full h-full bg-transparent resize-none outline-none text-slate-900 font-handwriting text-2xl leading-tight"
              placeholder="Scrivi qui..."
              value={note.text}
              onChange={(e) => updatePostIt(note.id, e.target.value)}
              onBlur={(e) => persistPostIt(note.id, e.target.value)}
              data-testid={`postit-textarea-${note.id}`}
            />
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); deletePostIt(note.id); }}
              className="absolute top-2 right-2 text-amber-800 hover:text-red-600 z-10 cursor-pointer p-1 rounded-full hover:bg-white/50 transition-colors"
              title="Elimina nota"
              data-testid={`delete-postit-${note.id}`}
            >
              <X size={22} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
